const filmsSearchOptions = {
    endpoint: 'trending/all/day',
    options: {
      page: 1,
      query: ""
    }
};

export default filmsSearchOptions;